import { ReactElement } from "react";
import {
  Dialog,
  IconButton,
  Box,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ErrorBoundary, Typography } from "@platform/design-system";

import { PolicyVariants } from "../../constants";
import { Policy } from "../../constants/aquafina";

import CoverageInformation from "./coverage-information";
import CoverageSubheader from "./coverage-subheader";

type PolicyDialogProps = {
  isOpen: boolean;
  policyDetailsInfo: Policy;
  subTitleText?: ReactElement<unknown>;
  groupName: string;
  carrierName: string;
  coverageName: string;
  variant: PolicyVariants;
  onClose: () => void;
};

const PolicyDialog = ({
  isOpen,
  policyDetailsInfo,
  subTitleText,
  groupName,
  carrierName,
  coverageName,
  variant,
  onClose,
}: PolicyDialogProps): React.JSX.Element | null => {
  if (!policyDetailsInfo) return null;
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xl">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="header-large" gap={1}>
            Policy Details
          </Typography>
          <Box display="flex" gap={2} alignItems="center">
            <IconButton aria-label="close" size="small" onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <ErrorBoundary>
        <CoverageSubheader
          groupName={groupName}
          carrier={carrierName}
          coverage={coverageName}
          subTitleText={subTitleText}
        />
        <DialogContent sx={{ paddingY: 0, paddingTop: 4 }}>
          <CoverageInformation
            policyDetailsInfo={policyDetailsInfo}
            variant={variant}
          />
        </DialogContent>
      </ErrorBoundary>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolicyDialog;
